module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "ch02"
    }
  }, [_c('a', {
    attrs: {
      "id": "page11"
    }
  }), _c('div', {
    staticClass: "chapterHead"
  }, [_c('h2', {
    staticClass: "chapterNumber"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', [_c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("CHAPTER TWO")])])])])])]), _c('div', {
    staticClass: "chapterBody"
  }, [_c('p', {
    staticClass: "chapterDateline"
  }, [_c('span', [_c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("London, England")])]), _c('br'), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("One Year Later")])])])]), _c('p', {
    staticClass: "chapterOpenerText"
  }, [_c('span', [_c('span', {
    staticClass: "chapterOpenerFirstLetters"
  }, [_c('span', [_c('span', {
    staticClass: "bold"
  }, [_c('span', [_vm._v("J")])])])]), _vm._v("ocelyn Caulfield stood in front of the cheval glass in her bedroom overlooking the gardens at Meadowbrook, her family’s mansion at the edge of Mayfair in a district of larger, newer homes. Dressed in a corset, chemise and drawers, the garments as ruffled as the white silk counterpane on her four-poster bed and the crisscross curtains at the windows, she surveyed her curvaceous figure in the mirror.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“I hope I am not putting on weight.” She clamped her hands on the bone stays that trimmed her waist to a scant eighteen inches and frowned, pulling her sleek, dark eyebrows together over a pair of violet eyes. “What do you think, Lily?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Her third cousin and companion of the past six years, Lily Moran, laughed from a few feet away. “You have a perfect figure and you know it.”")])]), _c('a', {
    attrs: {
      "id": "page12"
    }
  }), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Jocelyn smiled mischievously. “Do you think the duke will notice?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Lily just shook her head. “Every man who sees you notices, Jo.” Though the women were both average in height, unlike Jocelyn, Lily was blond and slender, with pale sea-green eyes and lips she considered a little too full. She was pretty in a more subtle, less vibrant way, not at all like Jo, who was the sort to stop a man where he stood and leave him simply staring.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Have you finished packing for the trip?” Jocelyn asked. Which meant, "), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("Lily, have you also finished mine?")])]), _vm._v(" Jo didn’t trust Elsie, her ladies’ maid, to choose exactly the right wardrobe for a trip to meet her soon-to-be betrothed, the Duke of Bransford. It was Lily she trusted, Lily, one year older, whom she had come to depend on over the years.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“I am nearly finished,” Lily said. “I have everything but your undergarments laid out for you in your dressing room. All you have to do is have Phoebe pack the gowns away in your trunks before you leave.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Jocelyn turned to survey her figure from a different angle. “I wonder what the house will be like. Father says Bransford Castle is quite a dreadful place—though I gather, until the last few years, it was one of the grandest homes in England. It isn’t truly a castle, you know. It is only three hundred years old. It is huge, Father says, four stories high, built in a U shape with an interior garden and any number of turrets and towers. It even has a hedge maze.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Jocelyn’s smile displayed a set of perfect white teeth. “Father says I should have a marvelous time putting it back to rights.”")])]), _c('a', {
    attrs: {
      "id": "page13"
    }
  }), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Lily smiled indulgently. “I am certain you will.” Though she imagined Jo would be bored with the project after the first six months and her mother would wind up finishing the remodeling and redecorating the newly titled duchess would require of her lavish country home.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“I hope Mother and I will be able to endure such quarters. I am glad we shan’t be staying much more than a week.” Just long enough for Jocelyn and her future betrothed to get acquainted. “I am so glad I decided you should travel to Bransford a few days early. That should give you time to make the place comfortable for us.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“I’m sure the duke will do everything in his power to see to you and your mother’s comfort, Jocelyn.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Jo reached over and took hold of Lily’s hand. “But you "), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("will")])]), _vm._v(" take care of it personally, won’t you? You know the things that please me…exactly how I like my cocoa in the mornings, how hot I like the water in my bath. You will prepare the servants, explain my special needs?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Of course.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Jocelyn started to turn away, then whirled back. “Oh, and don’t forget to take the dried rose petals. They scent my bath just perfectly.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“I won’t forget.” Lily had been taking care of Jocelyn since the day she had arrived at Meadowbrook six years ago. It had been quite a change for Lily, who had been living in poverty since her parents had died of the cholera when she was twelve years old.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("On her sixteenth birthday, her uncle, Jack Moran, had made the announcement that Lily would be leaving the attic garret where they lived. From that day forward, she would be residing with her wealthy cousin, Henry Caul"), _c('a', {
    attrs: {
      "id": "page14"
    }
  }), _vm._v("field, and his wife, Matilda, acting as companion to their fifteen-year-old daughter and only child, Jocelyn.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Lily hadn’t wanted to go. She loved her uncle. He and his friends were the only family she had, once her parents were gone. She had begged him to let her stay, but he had refused. Jack Moran was a sharper. He earned his living by taking money from other people. Once Lily had begun to mature into a woman, he was determined she would escape the sort of life he led.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("She remembered their last day together as if it were burned into her brain.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“It’s just too dangerous, Lily,” he had said. “’Twas only last week you dropped that man’s wallet and nearly got nabbed by the police. You’re growing up, luv, becoming a woman. I want you to have a better life, the kind your mama and papa would have wanted you to have. I should have done this long before now, but I…”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“You what, Uncle Jack?” she asked tearfully.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“But you’re all the family I have, luv, and I’m going to miss you.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Lily remembered how hard she had cried that day and the awful, sick feeling in her stomach when her uncle left her at the door of Henry Caulfield’s mansion. She hadn’t seen Uncle Jack since that fateful day and Lord, how she missed him. Yet, deep down inside, she knew he had done the right thing.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Lily looked over at Jocelyn. “I shall be leaving first thing in the morning. The newspaper says a storm may be coming in, perhaps even snow. I want to get there ahead of the weather.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Do take the traveling coach, dear. Just send it back once you arrive. If it should rain or snow, Mother and I "), _c('a', {
    attrs: {
      "id": "page15"
    }
  }), _vm._v("will wait a few more days, leave as soon as it clears enough to travel. That should give you plenty of time to put things in order.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“I am certain it will.” Lily walked over to the gilt and ivory dresser and began to sort through Jocelyn’s nightwear, choosing what to include in her trunks. “I heard the duke’s aunt Agatha will be there to act as hostess for our visit.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“So I gather. I’ve never met her. Apparently, she rarely comes to London.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Nor does your duke.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Jo sniffed as if the thought was entirely repugnant. “I am certain, once we are wed, that will change.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Lily just smiled and pulled out a soft cotton nightgown with roses embroidered around the ruffled neckline. “They say your duke is quite something—tall and well built, with hair the color of ancient gold. I’ve heard he is incredibly handsome.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("One of Jocelyn’s dark eyebrows went up. “He had better be. I shan’t marry him if he is unpleasant to look at—even if he is a duke.”11")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("But Lily imagined that Jo would marry the man no matter what he looked like. She wanted to be a duchess. She wanted to continue the lavish lifestyle she was used to, wanted the attention and high-ranking social position that came with the title. In truth, Jocelyn wanted everything.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("And thanks to a father who spoiled her no end, she usually got what she wanted.")])]), _c('p', {
    staticClass: "star"
  }, [_vm._v("* * *")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', [_vm._v("“You are leaving, Your Grace?” The butler, Jeremy Greaves, hurried forward as Royal strode across the "), _c('a', {
    attrs: {
      "id": "page16"
    }
  }), _vm._v("entry toward the door. “If I may be so bold, Your Grace, your visitors are expected to arrive at any moment. What will your betrothed think if you are not here to greet her?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("What indeed?")])]), _vm._v(" “I remind you, Greaves, we are not yet officially betrothed.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“I understand, sir. Still, she will expect you to properly welcome her to Bransford Castle.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("Undoubtedly")])]), _vm._v(". It was the height of bad manners to be gone from the house when the lady and her mother arrived. He glanced at his butler, a gray-haired old man with watery blue eyes, and kept walking. It occurred to him that few servants would be bold enough to gainsay a duke, but that didn’t stop Greaves or Middleton, who had lived at Bransford since before Royal was born.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“If she gets here before my return,” he said, “tell her I was called out unexpectedly. Tell her I will be back very shortly.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“But, sir—”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Pulling on his kidskin gloves, Royal continued toward the heavy wooden door. Greaves scurried ahead and pulled it open, and Royal strode outside.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("A storm had blown in last night, but instead of raining, it had snowed. He paused at the top of the wide stone steps to survey the beauty of the frozen landscape, the sun shining down through the clouds, making the countryside glisten. The circular drive in front of the house was covered by several inches of snow and the naked branches of the trees along the lane glittered with a sparkling layer of gleaming white.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Royal took a deep breath of the clean, crisp air and descended the steps. One of the grooms had his gray "), _c('a', {
    attrs: {
      "id": "page17"
    }
  }), _vm._v("stallion, Jupiter, saddled and waiting. Fortunately, his father hadn’t had the heart to sell Royal’s favorite horse. Dressed in riding breeches, a dark blue tailcoat and high black boots, he vaulted into the saddle, his heavy scarlet cloak swirling out around him.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("He whirled the stallion, nudged the animal into a trot, then a canter, the sound of hoofbeats muffled by the thick layer of snow. As Jupiter carried him down the road, he cast a last glance at poor old Greaves, who stared worriedly from the porch.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("He would be back at the house before Jocelyn arrived, he told himself. In the meanwhile, he needed a little time to prepare. The fact he’d had more than a year to ready himself for this meeting seemed inconsequential. He simply wasn’t yet ready for marriage and certainly not to a woman he had never met.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Still, he would keep his word.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Royal urged the stallion into a gallop and turned off on a narrow dirt road that bordered the fields surrounding the house. It was white for as far as he could see, the trees twinkling in the sunshine as if they’d been sprayed with starlight.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Twelve thousand acres surrounded Bransford Castle. That much land meant dozens of tenants, all of whom looked to him to make important decisions. The acreage was entailed with the title, or much of it would probably have been sold.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Royal shifted in the saddle. He didn’t want to think of his duties now. He simply wanted to clear his head and prepare himself to meet the woman who would share his future.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("He rode for a while, took several different lanes and "), _c('a', {
    attrs: {
      "id": "page18"
    }
  }), _vm._v("crossed a half-dozen fields. It was time he returned to the house, time to accept what could not be changed.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("He took a different route home, skirting a dense grove of yew trees and eventually winding up on the road leading from the village to the castle. As he rounded a bend in the lane, something glinted off the snow up ahead. With the sun reflecting off the ice, it was incredibly bright. Royal squinted and tried to make out what it was.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Urging the horse from a walk to a canter, he rode closer, began to hear an odd, creaking sound in the light breeze blowing off the fields. All of a sudden, the images all came together, a carriage lying on its side, one of the wheels spinning whenever the breeze pushed it. In the field to the left, the carriage horses, still in their traces, stood huddled together as if awaiting further instruction.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Royal spotted the coachman lying next to the road. He urged the stallion closer, rode up beside him and swung down from the saddle. Kneeling next to the driver who lay unconscious in the snow, he checked for cuts or broken bones. A nasty gash on the head seemed the man’s only injury. Royal made a quick survey of the area, searching for anyone who might have been in the carriage and been thrown from the coach. He climbed up and looked through the open door, but saw no one and returned to the man on the ground.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Apparently sensing Royal’s presence, the coachman groaned and began to awaken.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Take it easy, friend. There’s been an accident. Don’t try to move too swiftly.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("The beefy man swallowed, moving his Adam’s apple up and down. “The lady…? Is she…is she all right?”")])]), _c('a', {
    attrs: {
      "id": "page19"
    }
  }), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Worry gripped him. A woman had been in the carriage. Royal glanced back at the overturned conveyance, noticing for the first time the opulence of the gleaming black coach. His gaze shot to the four blooded bay horses in the field, animals of the finest caliber, and a chill went down his spine.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Jocelyn…” Rising swiftly to his feet, he began a second search of the area around the coach. Vast fields of white blinded him and for a moment, he couldn’t see. A further search and he spotted her, lying like a broken doll in the thick layer of white covering the field. She was dressed in a modestly cut gown of rose velvet, her fur-lined cloak bunched beneath her still figure.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Royal hurried toward her, knelt at her side. He checked for a pulse and felt a strong, steady throbbing beneath the soft skin at the base of her throat. She was unconscious, but he saw no blood or other obvious injuries. He gently checked her limbs for broken bones but discovered none that he could see. He prayed her injuries were not internal and that she would soon recover.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("When a soft moan slipped from her lips, he took her cold hand and rubbed it between his gloved fingers, hoping to warm her, hoping she would awaken. “It is all right,” he soothed. “I’m the Duke of Bransford and I’m going to take you home.” He was hesitant to move her, but when her eyes fluttered, lifting long golden lashes away from her pale cheeks, he breathed a sigh of relief.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Your…Grace,” she whispered.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Just lie still. There was an accident. You’re safe now and everything is going to be all right.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("For the first time, he allowed himself to look at her. "), _c('a', {
    attrs: {
      "id": "page20"
    }
  }), _vm._v("She was as beautiful as his father had said, with a slender figure and delicate features. Lying in the snow, her skin was nearly the same white hue. Her mouth was full, her lips delicately curved, though paler, he imagined, than they usually were. A bonnet fashioned of the same rose velvet as her gown lay several feet away. Her golden hair had come loose from its pins and tumbled around her slender shoulders. Her eyes opened wider, a lovely pale shade of green.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("She moistened her lips. “I think I…must have hit my head.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Yes…Perhaps when you were tossed from the carriage.” He removed his glove and felt her cheeks, her forehead, as smooth and clear as glass. “Are you hurt? Can you tell where you might be injured?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Her pretty mouth faintly curved. “I am too cold to know.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("He almost smiled. He could feel her shivering and wondered how long she had been lying out here in the snow. He thanked God he had come along when he did. “I need to get you somewhere warm. I’m going to lift you. If it hurts in any way, tell me and I will stop.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("She nodded and her eyes slid closed. Very carefully he lifted her into his arms and cradled her against his chest. The big gray stallion stood a few feet away. Royal set her sideways in the saddle then swung up behind her, settled her gently in front of him and eased her back against his chest.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“All right?” he asked, sliding his arm protectively around her waist to hold her securely in place.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("She turned her head and her sea-green eyes fluttered open. When they settled on his face, something tugged "), _c('a', {
    attrs: {
      "id": "page21"
    }
  }), _vm._v("deep inside him. Royal felt as if a hand had reached inside his chest and begun to squeeze his heart.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Just a little…dizzy.” Her eyes slowly closed, then flashed open again. “The coachman…Mr. Gibbons…is he…is he all right?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Royal’s gaze went in search of the man. The driver was on his feet and walking into the field to collect the horses.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“He appears to be fine. Was there anyone else in the carriage?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“No, just me.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Her mother was to have come with her, he thought. It seemed odd she would be traveling without so much as a ladies’ maid.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("The explanation would have to wait. Royal rode toward the coachman, careful to keep a firm hold on the lady in his arms.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Can you make it back to the village?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("The driver grunted a yes. “Just a bit of a bash on the head, is all. I’ll ride the wheelhorse back to town, get the animals properly stabled till I can put the carriage to rights.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Good man. I’m the Duke of Bransford. I’ll see to the lady. If you need anything, just send word to the house. Everyone knows where it is.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Twere highwaymen,” the man said darkly. “Tried to outrun ’em, but there were ice on the road. They were gone when ye got here?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“I saw no one, just the overturned carriage.” A jolt of anger followed his answer. Brigands had attacked the coach! Perhaps they had searched the overturned vehicle and taken anything of value. A similar incident had happened a month ago on the road outside Swans"), _c('a', {
    attrs: {
      "id": "page22"
    }
  }), _vm._v("downe, a nearby village. Royal had hoped it was a onetime occurrence.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("He flicked a last glance at the coachman, caught a wave as the stout man began leading the horses onto the road then swung up on the back of the wheelhorse. Royal watched him ride away, thinking of the highwaymen who had caused the accident. He gazed out across the fields but saw no sign of them.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("An angry sigh whispered out, turning white in the frosty air. He would worry about the highwaymen in due course. In the meantime, his lady needed care.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Royal returned his attention to the woman in his arms—the woman he was going to marry. As he looked into the serenity of her lovely pale face and recalled her sweetly feminine figure and soft green eyes, he thought that perhaps being married wouldn’t be such a terrible fate after all.")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-07c6f5a8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Chapter-02.vue
// module id = 72
// module chunks = 0